import { render, staticRenderFns } from "./DiscoverPage.vue?vue&type=template&id=5c036424"
import script from "./DiscoverPage.vue?vue&type=script&lang=js"
export * from "./DiscoverPage.vue?vue&type=script&lang=js"
import style0 from "./DiscoverPage.vue?vue&type=style&index=0&id=5c036424&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports